import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import { FC } from "react";

export const ArrowUpIconSvg = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.625 8.75L7.5 5.625L4.375 8.75"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowUpIcon: FC<Partial<CustomIconComponentProps>> = (props) => (
  <Icon component={ArrowUpIconSvg} {...props} />
);

export default ArrowUpIcon;

ArrowUpIcon.displayName = "ArrowUpIcon";
